// supported YAMS hosts
// also used as source to generate CRS rules
export const YAMS_HOSTS = [
    'ca.staticassets.cloud',
    'au.staticassets.cloud',
    'img.staticassets.cloud',
    'catalog.staticassets.cloud',
    'media.kijiji.ca',
    'static.gumtree.com.au'
];
